function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "XMLID_439_"
}, React.createElement("path", {
  id: "XMLID_440_",
  d: "M188.295,141.768c8.109,3.83,17.158,5.982,26.705,5.982c34.601,0,62.75-28.149,62.75-62.75 S249.601,22.25,215,22.25c-9.547,0-18.596,2.152-26.705,5.982c6.133,7.9,11.018,16.813,14.358,26.442 c3.299,9.508,5.097,19.71,5.097,30.326s-1.798,20.818-5.097,30.326C199.313,124.955,194.428,133.868,188.295,141.768z"
}), React.createElement("path", {
  id: "XMLID_441_",
  d: "M203.91,178.289c11.508,8.959,21.631,19.613,30,31.583c13.73,19.641,22.73,42.82,25.317,67.878 c0.509,4.932,0.772,9.935,0.772,15c0,5.258-0.915,10.305-2.58,15H315c8.284,0,15-6.716,15-15c0-63.411-51.589-115-115-115 C211.287,177.75,207.586,177.933,203.91,178.289z"
}), React.createElement("path", {
  id: "XMLID_443_",
  d: "M115,147.75c20.389,0,38.531-9.78,50-24.889c7.994-10.532,12.75-23.649,12.75-37.861 S172.994,57.671,165,47.139C153.531,32.03,135.389,22.25,115,22.25c-34.601,0-62.75,28.149-62.75,62.75S80.399,147.75,115,147.75z"
}), React.createElement("path", {
  id: "XMLID_444_",
  d: "M15,307.75h200c8.284,0,15-6.716,15-15c0-5.083-0.336-10.089-0.979-15 c-3.45-26.373-15.873-49.96-34.092-67.597c-8.762-8.481-18.861-15.589-29.951-20.964C149.856,181.863,132.9,177.75,115,177.75 c-63.411,0-115,51.589-115,115C0,301.034,6.716,307.75,15,307.75z"
}));

var SvgIconEmployees = function SvgIconEmployees(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 330",
    style: {
      enableBackground: "new 0 0 330 330"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconEmployees, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_employees.bc8910a1.svg";
export { ForwardRef as ReactComponent };